export default "__VITE_ASSET__CoKXvUZG__"